// extracted by mini-css-extract-plugin
module.exports = {"artikkelDato":"ArtikkelDato_artikkelDato__zoE3K"};